import axios from 'axios';
import lodash from 'lodash';
import Popup from './Popup';

const responseCheckRedirect = (response) => {
    if (response.isRedirect === true && response.url) {
        window.location = response.url;
    }
    return response;
};

const responceCheckConnectTimeout = (response) => {
    if (response.status === 'connection_timeout' && !Popup.isActive()) {
        Popup.notify(response.error);
    }
    return response;
};

const responseKeysToCamelCase = (data) => {
    if (data === undefined || !data) {
        return data;
    }

    let result = '';

    if (Array.isArray(data)) {
        result = data.map(item => responseKeysToCamelCase(item));
    } else if (typeof data === 'object') {
        result = {};
        Object.keys(data).forEach((key) => {
            result[lodash.camelCase(key)] = responseKeysToCamelCase(data[key]);
        });
    } else {
        result = data;
    }
    return result;
};

axios.defaults.timeout = 320000;

const Api = {
    debug: false,

    get(url, data = {}) {
        const params = {
            ...data
        };
        params.timestamp = Date.now();

        return axios({
            method: 'get',
            url,
            params
        })
            .then((response) => {
                if (this.debug) {
                    console.log('get', url, params, response.data);
                }
                return response;
            })
            .then(response => responseKeysToCamelCase(response.data))
            .then(responseCheckRedirect)
            .then(responceCheckConnectTimeout);
    },
    post(url, data = {}) {
        const params = {
            ...data
        };

        const formData = new FormData();
        Object.keys(params).forEach((key) => {
            const item = params[key];
            if (Array.isArray(item)) {
                item.forEach((value) => {
                    formData.append(`${key}[]`, value);
                });
            } else {
                formData.append(key, params[key]);
            }
        });

        return axios.post(url, formData)
            .then((response) => {
                if (this.debug) {
                    console.log('get', url, params, response.data);
                }
                return response;
            })
            .then(response => responseKeysToCamelCase(response.data))
            .then(responseCheckRedirect)
            .then(responceCheckConnectTimeout);
    }
};

export default Api;
